// extracted by mini-css-extract-plugin
export default {"signature":"app__css__app-pages-SelfHelp-signCheckInPledge-__index__signature"};